import { Routes, Route } from "react-router-dom";

import Home from "../institucional/home";
import Sobre from "../../shared/components/sobre/Sobre";
import BlogPage from "../institucional/blog/blogPage";
import ArticlePage from "../institucional/blog/ArticlePage";
import Cities from "../../shared/components/cities/Cities";
import Contact from "../../shared/components/contact/Contact";
import Privacy from "./Privacy";
import Conversion from "../../shared/components/conversion/Conversion";

export default function InstitucionalRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/sobre" element={<Sobre />} />
      <Route path="/blog" element={<BlogPage />} />
      <Route path="/blog/artigos/:id" element={<ArticlePage />} />
      <Route path="/city/:id" element={<Cities />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/Policy" element={<Privacy />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/conversion/:id" element={<Conversion />} />
    </Routes>
  );
}
